import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/BasketItemPerson`;

const ApiBasketItemPerson = {

  cancleBasketItemPerson : (params) => { 
    const url = `${baseServiceUrl}/CancelBasketItemPerson`;
    return ServiceApi.post(url, params );
  },
  
  getBasketCancelType : () =>{ 
    const url = `${baseServiceUrl}/GetBasketCancelType` ;
    
    return ServiceApi.get(url );
  }
};

export default ApiBasketItemPerson;


